import ApplicationController from '../application_controller'
import { post } from '@rails/request.js'

export default class extends ApplicationController {
  async switchActivity (event) {
    const checkbox = event.currentTarget
    const active = checkbox.checked
    const id = checkbox.value

    checkbox.disabled = true

    try {
      const response = await post(`/attachment_types/${id}/switch_activity`, {
        body: { active }
      })

      if (!response.ok) {
        checkbox.checked = !active
        console.error(this.errorMessage(active))
      }
    } catch (error) {
      checkbox.checked = !active
      console.error(this.errorMessage(active), error)
    } finally {
      checkbox.disabled = false
    }
  }

  errorMessage (active) {
    return `Failed to ${active ? 'activate' : 'deactivate'} attachment type`
  }
}
